import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'
import type { PushSubscriptionResource } from '@/types/notifications'

export interface BrowserPushSubscriptionPayload {
  endpoint: string
  keys: {
    p256dh: string
    auth: string
  }
  content_encoding: 'aes128gcm'
}

export interface VapidPublicKeyResponse {
  publicKey: string
  enabled: boolean
}

export const pushApi = {
  getVapidPublicKey: async (): Promise<VapidPublicKeyResponse> => {
    const response = await apiClient.get<{ data: { public_key: string; enabled: boolean } }>(
      API_ENDPOINTS.PUSH.VAPID_PUBLIC_KEY,
    )
    return {
      publicKey: response.data.data.public_key ?? '',
      enabled: Boolean(response.data.data.enabled),
    }
  },

  listSubscriptions: async (): Promise<PushSubscriptionResource[]> => {
    const response = await apiClient.get<{ data: PushSubscriptionResource[] }>(
      API_ENDPOINTS.PUSH.SUBSCRIPTIONS,
    )
    return response.data.data
  },

  subscribe: async (
    payload: BrowserPushSubscriptionPayload,
  ): Promise<PushSubscriptionResource> => {
    const response = await apiClient.post<{ data: PushSubscriptionResource }>(
      API_ENDPOINTS.PUSH.SUBSCRIPTIONS,
      {
        endpoint: payload.endpoint,
        public_key: payload.keys.p256dh,
        auth_token: payload.keys.auth,
        content_encoding: payload.content_encoding,
      },
    )
    return response.data.data
  },

  unsubscribe: async (id: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.PUSH.SUBSCRIPTION(id))
  },
}
